// Music banners - English (no locale suffix)
const MUSIC_DESKTOP =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_desktop-2.webp';
const MUSIC_MOBILE =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_mobile-2.webp';
const MUSIC_TABLET =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_tablet-2.webp';

// Music banners - German (DE_DE)
const MUSIC_DESKTOP_DE_DE =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_desktop_DE_DE_dec2025.webp';
const MUSIC_MOBILE_DE_DE =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_mobile_DE_DE_dec2025.webp';
const MUSIC_TABLET_DE_DE =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_tablet_DE_DE_dec2025.webp';

// Music banners - Spanish Spain (ES_ES)
const MUSIC_DESKTOP_ES_ES =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_desktop_ES_ES_dec2025.webp';
const MUSIC_MOBILE_ES_ES =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_mobile_ES_ES_dec2025.webp';
const MUSIC_TABLET_ES_ES =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_tablet_ES_ES_dec2025.webp';

// Music banners - Spanish Mexico (ES_MX)
const MUSIC_DESKTOP_ES_MX =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_desktop_ES_MX_dec2025.webp';
const MUSIC_MOBILE_ES_MX =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_mobile_ES_MX_dec2025.webp';
const MUSIC_TABLET_ES_MX =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_tablet_ES_MX_dec2025.webp';

// Music banners - French Canada (FR_CA)
const MUSIC_DESKTOP_FR_CA =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_desktop_FR_CA_dec2025.webp';
const MUSIC_MOBILE_FR_CA =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_mobile_FR_CA_dec2025.webp';
const MUSIC_TABLET_FR_CA =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_tablet_FR_CA_dec2025.webp';

// Music banners - French France (FR_FR)
const MUSIC_DESKTOP_FR_FR =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_desktop_FR_FR_dec2025.webp';
const MUSIC_MOBILE_FR_FR =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_mobile_FR_FR_dec2025.webp';
const MUSIC_TABLET_FR_FR =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_tablet_FR_FR_dec2025.webp';

// Music banners - Italian (IT_IT)
const MUSIC_DESKTOP_IT_IT =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_desktop_IT_IT_dec2025.webp';
const MUSIC_MOBILE_IT_IT =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_mobile_IT_IT_dec2025.webp';
const MUSIC_TABLET_IT_IT =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_tablet_IT_IT_dec2025.webp';

// Music banners - Dutch (NL_NL)
const MUSIC_DESKTOP_NL_NL =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_desktop_NL_NL_dec2025.webp';
const MUSIC_MOBILE_NL_NL =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_mobile_NL_NL_dec2025.webp';
const MUSIC_TABLET_NL_NL =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_tablet_NL_NL_dec2025.webp';

// Music banners - Portuguese Brazil (PT_BR)
const MUSIC_DESKTOP_PT_BR =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_desktop_PT_BR_dec2025.webp';
const MUSIC_MOBILE_PT_BR =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_mobile_PT_BR_dec2025.webp';
const MUSIC_TABLET_PT_BR =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_tablet_PT_BR_dec2025.webp';

// Music banners - Portuguese Portugal (PT_PT)
const MUSIC_DESKTOP_PT_PT =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_desktop_PT_PT_dec2025.webp';
const MUSIC_MOBILE_PT_PT =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_mobile_PT_PT_dec2025.webp';
const MUSIC_TABLET_PT_PT =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.29.24/browser/static/images/home/seasonal/music_tablet_PT_PT_dec2025.webp';

/**
 * =============================================================================
 * DEPRECATED ASSETS AND OLD SYSTEM (Replaced December 2024)
 * =============================================================================
 *
 * The previous homepage banner system has been replaced with a locale-aware
 * music banner system. All deprecated assets, banner data objects, and TLD
 * constants have been removed from this file.
 *
 * For historical reference and migration information, see:
 * - docs/DEPRECATED_ASSETS.md - List of all old banner asset URLs
 * - docs/SYSTEM_OVERVIEW.md - How the current system works
 * - docs/ARCHITECTURE.md - System architecture and data flow diagram
 *
 * =============================================================================
 */

// SEASONAL BANNER ASSETS - Used for English locales
const HOLIDAY_DESKTOP =
    'https://eventbrite-build.s3.amazonaws.com/fe/build/images/3df63268f64805c82a5cafefdc889f01-holiday_desktop.webp';
const HOLIDAY_MOBILE =
    'https://eventbrite-build.s3.amazonaws.com/fe/build/images/64e30f923409c9650945c12d6ae197d4-holiday_mobile.webp';
const HOLIDAY_TABLET =
    'https://eventbrite-build.s3.amazonaws.com/fe/build/images/a3d7210c51ff07920ab78bbc7888d855-holiday_tablet.webp';

// SPOTLIGHT BANNER ASSETS - Used for English locales
const BOSTON_LEGACY_DESKTOP =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.33.0/browser/static/images/home/spotlight/desktop_boston_legacy.webp';
const BOSTON_LEGACY_MOBILE =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.33.0/browser/static/images/home/spotlight/mobile_boston_legacy.webp';
const BOSTON_LEGACY_TABLET =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.33.0/browser/static/images/home/spotlight/tablet_boston_legacy.webp';

const LITTLE_VENICE_FILM_FESTIVAL_DESKTOP =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.38.0/browser/static/images/home/spotlight/desktop_little_venice_film_festival.webp';
const LITTLE_VENICE_FILM_FESTIVAL_MOBILE =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.38.0/browser/static/images/home/spotlight/mobile_little_venice_film_festival.webp';
const LITTLE_VENICE_FILM_FESTIVAL_TABLET =
    'https://eventbrite-build.s3.amazonaws.com/fe/dist/discover-lib/11.38.0/browser/static/images/home/spotlight/tablet_little_venice_film_festival.webp';

export const DOT_WIDTH = 10;
export const DOT_HEIGHT = 8;
export const DOT_FILL_ACTIVE = '#716B7A';
export const DOT_FILL_INACTIVE = 'white';
export const DOT_RADIUS = 4;

export interface FullbleedHeaderData {
    imageSet: {
        mobile: string;
        tablet: string;
        desktop: string;
    };
    altText: string;
    instrumentationText: string;
    ctaLink: string;
}

export const MUSIC_BANNER_EN: FullbleedHeaderData = {
    imageSet: {
        mobile: MUSIC_MOBILE,
        tablet: MUSIC_TABLET,
        desktop: MUSIC_DESKTOP,
    },
    altText: 'Music Events',
    instrumentationText: 'music',
    ctaLink: '/d/local/music--events--this-week/',
};

export const MUSIC_BANNER_DE_DE: FullbleedHeaderData = {
    imageSet: {
        mobile: MUSIC_MOBILE_DE_DE,
        tablet: MUSIC_TABLET_DE_DE,
        desktop: MUSIC_DESKTOP_DE_DE,
    },
    altText: 'Music Events',
    instrumentationText: 'music_de_de',
    ctaLink: '/d/local/music--events--this-week/',
};

export const MUSIC_BANNER_ES_ES: FullbleedHeaderData = {
    imageSet: {
        mobile: MUSIC_MOBILE_ES_ES,
        tablet: MUSIC_TABLET_ES_ES,
        desktop: MUSIC_DESKTOP_ES_ES,
    },
    altText: 'Music Events',
    instrumentationText: 'music_es_es',
    ctaLink: '/d/local/music--events--this-week/',
};

export const MUSIC_BANNER_ES_MX: FullbleedHeaderData = {
    imageSet: {
        mobile: MUSIC_MOBILE_ES_MX,
        tablet: MUSIC_TABLET_ES_MX,
        desktop: MUSIC_DESKTOP_ES_MX,
    },
    altText: 'Music Events',
    instrumentationText: 'music_es_mx',
    ctaLink: '/d/local/music--events--this-week/',
};

export const MUSIC_BANNER_FR_CA: FullbleedHeaderData = {
    imageSet: {
        mobile: MUSIC_MOBILE_FR_CA,
        tablet: MUSIC_TABLET_FR_CA,
        desktop: MUSIC_DESKTOP_FR_CA,
    },
    altText: 'Music Events',
    instrumentationText: 'music_fr_ca',
    ctaLink: '/d/local/music--events--this-week/',
};

export const MUSIC_BANNER_FR_FR: FullbleedHeaderData = {
    imageSet: {
        mobile: MUSIC_MOBILE_FR_FR,
        tablet: MUSIC_TABLET_FR_FR,
        desktop: MUSIC_DESKTOP_FR_FR,
    },
    altText: 'Music Events',
    instrumentationText: 'music_fr_fr',
    ctaLink: '/d/local/music--events--this-week/',
};

export const MUSIC_BANNER_IT_IT: FullbleedHeaderData = {
    imageSet: {
        mobile: MUSIC_MOBILE_IT_IT,
        tablet: MUSIC_TABLET_IT_IT,
        desktop: MUSIC_DESKTOP_IT_IT,
    },
    altText: 'Music Events',
    instrumentationText: 'music_it_it',
    ctaLink: '/d/local/music--events--this-week/',
};

export const MUSIC_BANNER_NL_NL: FullbleedHeaderData = {
    imageSet: {
        mobile: MUSIC_MOBILE_NL_NL,
        tablet: MUSIC_TABLET_NL_NL,
        desktop: MUSIC_DESKTOP_NL_NL,
    },
    altText: 'Music Events',
    instrumentationText: 'music_nl_nl',
    ctaLink: '/d/local/music--events--this-week/',
};

export const MUSIC_BANNER_PT_BR: FullbleedHeaderData = {
    imageSet: {
        mobile: MUSIC_MOBILE_PT_BR,
        tablet: MUSIC_TABLET_PT_BR,
        desktop: MUSIC_DESKTOP_PT_BR,
    },
    altText: 'Music Events',
    instrumentationText: 'music_pt_br',
    ctaLink: '/d/local/music--events--this-week/',
};

export const MUSIC_BANNER_PT_PT: FullbleedHeaderData = {
    imageSet: {
        mobile: MUSIC_MOBILE_PT_PT,
        tablet: MUSIC_TABLET_PT_PT,
        desktop: MUSIC_DESKTOP_PT_PT,
    },
    altText: 'Music Events',
    instrumentationText: 'music_pt_pt',
    ctaLink: '/d/local/music--events--this-week/',
};

export const HOLIDAY_DATA: FullbleedHeaderData = {
    imageSet: {
        mobile: HOLIDAY_MOBILE,
        tablet: HOLIDAY_TABLET,
        desktop: HOLIDAY_DESKTOP,
    },
    altText: 'Holiday Banner',
    instrumentationText: 'holiday',
    ctaLink: '/d/local/paid--events/winter-holiday/',
};

export const BOSTON_LEGACY_BANNER: FullbleedHeaderData = {
    imageSet: {
        mobile: BOSTON_LEGACY_MOBILE,
        tablet: BOSTON_LEGACY_TABLET,
        desktop: BOSTON_LEGACY_DESKTOP,
    },
    altText: 'Boston Legacy FC Spotlight Banner',
    instrumentationText: 'boston legacy fc spotlight',
    ctaLink: '/e/314-day-one-2026-inaugural-match-tickets-1984094228247',
};

export const LITTLE_VENICE_FILM_FESTIVAL_BANNER: FullbleedHeaderData = {
    imageSet: {
        mobile: LITTLE_VENICE_FILM_FESTIVAL_MOBILE,
        tablet: LITTLE_VENICE_FILM_FESTIVAL_TABLET,
        desktop: LITTLE_VENICE_FILM_FESTIVAL_DESKTOP,
    },
    altText: 'Little Venice Film Festival Spotlight Banner',
    instrumentationText: 'little venice film festival spotlight',
    ctaLink: '/o/little-venice-film-festival-73006723603',
};
const MUSIC_BANNERS_BY_LOCALE: Record<string, FullbleedHeaderData> = {
    // English variants (all use same English assets)
    en_US: MUSIC_BANNER_EN, // US -> English
    en_CA: MUSIC_BANNER_EN, // Canada -> US fallback
    en_GB: MUSIC_BANNER_EN, // UK -> US fallback
    en_AU: MUSIC_BANNER_EN, // Australia -> US fallback
    en_NZ: MUSIC_BANNER_EN, // New Zealand -> US fallback
    en_IE: MUSIC_BANNER_EN, // Ireland -> US fallback
    en_DK: MUSIC_BANNER_EN, // Denmark (English)
    en_FI: MUSIC_BANNER_EN, // Finland (English)
    en_HK: MUSIC_BANNER_EN, // Hong Kong (English)
    en_SG: MUSIC_BANNER_EN, // Singapore (English)
    en_SE: MUSIC_BANNER_EN, // Sweden (English)

    // German (de_DE assets)
    de_DE: MUSIC_BANNER_DE_DE, // Germany -> German
    de_AT: MUSIC_BANNER_DE_DE, // Austria -> Germany fallback
    de_CH: MUSIC_BANNER_DE_DE, // Switzerland -> Germany fallback

    // Spanish
    es_ES: MUSIC_BANNER_ES_ES, // Spain -> Spain Spanish
    es_MX: MUSIC_BANNER_ES_MX, // Mexico -> Mexico Spanish
    es_AR: MUSIC_BANNER_ES_MX, // Argentina -> Mexico fallback
    es_CL: MUSIC_BANNER_ES_MX, // Chile -> Mexico fallback
    es_CO: MUSIC_BANNER_ES_MX, // Colombia -> Mexico fallback
    es_PE: MUSIC_BANNER_ES_MX, // Peru -> Mexico fallback

    // French
    fr_FR: MUSIC_BANNER_FR_FR, // France -> French
    fr_CA: MUSIC_BANNER_FR_CA, // Canada -> Canadian French
    fr_BE: MUSIC_BANNER_FR_FR, // Belgium French -> France fallback
    fr_CH: MUSIC_BANNER_FR_FR, // Switzerland French -> France fallback

    // Italian
    it_IT: MUSIC_BANNER_IT_IT, // Italy Italian

    // Dutch
    nl_NL: MUSIC_BANNER_NL_NL, // Neatherlands -> Dutch
    nl_BE: MUSIC_BANNER_NL_NL, // Belgium Dutch -> Neltherlands fallback

    // Portuguese
    pt_BR: MUSIC_BANNER_PT_BR, // Brazil -> Brazil Portuguese
    pt_PT: MUSIC_BANNER_PT_PT, // Portugal
};

function getMusicBannerForLocale(locale: string): FullbleedHeaderData {
    return MUSIC_BANNERS_BY_LOCALE[locale] || MUSIC_BANNER_EN;
}

// Hardcoded seasonal flag - change here if seasonal campaigns need to be disabled
const ENABLE_SEASONAL_MODULE = false;

// Single seasonal banner array (replaces regional variants)
const SEASONAL_BANNERS: FullbleedHeaderData[] = [HOLIDAY_DATA];

/**
 * Gets the banner carousel data based on locale
 * @param locale - The locale string (e.g., 'en_US', 'es_MX', 'fr_CA')
 * @returns Array of banner data objects for the carousel
 */
export function getBannerCarouselData(
    locale: string,
    enableLittleVeniceSpotlight?: boolean,
): FullbleedHeaderData[] {
    // Determine if locale is English-speaking
    const isEnglish = locale.startsWith('en_');
    const isUnitedKingdom = locale === 'en_GB';

    // English locales with seasonal enabled: Use seasonal carousel
    // check if feature flag is enabled and locale is in the list of English locales

    if (enableLittleVeniceSpotlight && isUnitedKingdom) {
        // check for united kingdom
        return [LITTLE_VENICE_FILM_FESTIVAL_BANNER];
    }

    if (isEnglish && ENABLE_SEASONAL_MODULE) {
        // Return multi-slide seasonal carousel: [NYE, HOLIDAY]
        return SEASONAL_BANNERS;
    }

    // Non-English OR English without seasonal: Use localized music banner
    const musicBanner = getMusicBannerForLocale(locale);
    return [musicBanner]; // Single-slide carousel with music banner
}

export const DEFAULT_BANNER_INDEX = 0;
